import { gql } from '@apollo/client';

/**
 * 802.1X EapProfile — CRUD + validate operations.
 *
 * Spec: docs/specs/19-optiedge-mdm/802.1x/frank/01-plan-auth-profile.md §4.
 *
 * EapProfile carries the EAP authentication material (PEAP / EAP-TLS) plus
 * cert metadata. Network profiles reference EapProfile via `eapProfileId`
 * FK when `security === WPA2_ENTERPRISE`. Secrets (peapPassword,
 * certificateInfo, privateKeyInfo, keyPassphrase, caCertificateInfo) are
 * decrypted on read and never selected into the fragment below — they're
 * fetched only when the form needs them (Edit dialog).
 */

export const EAP_PROFILE_FIELDS = gql`
  fragment EapProfileFields on EapProfile {
    _id
    name
    authentication
    identity
    certificateFilename
    certificateFormat
    privateKeyFilename
    caCertificateFilename
    domainSuffixMatch
    expiresAt
    certCommonName
    encrypted
    createdAt
  }
`;

export const EAP_PROFILES_QUERY = gql`
  query eapProfiles($teamId: String, $filter: QueryEapProfileInput) {
    eapProfiles(teamId: $teamId, filter: $filter) {
      ...EapProfileFields
    }
  }
  ${EAP_PROFILE_FIELDS}
`;

export const EAP_PROFILE_DETAIL_QUERY = gql`
  query eapProfileDetail($_id: String!) {
    eapProfileDetail(_id: $_id) {
      ...EapProfileFields
    }
  }
  ${EAP_PROFILE_FIELDS}
`;

export const SAVE_EAP_PROFILE = gql`
  mutation saveEapProfile($teamId: String, $payload: EapProfileInput!) {
    saveEapProfile(teamId: $teamId, payload: $payload) {
      ...EapProfileFields
    }
  }
  ${EAP_PROFILE_FIELDS}
`;

export const DELETE_EAP_PROFILE = gql`
  mutation deleteEapProfile($_id: String!) {
    deleteEapProfile(_id: $_id)
  }
`;

export const VALIDATE_EAP_PROFILE = gql`
  mutation validateEapProfile($input: EapProfileInput!) {
    validateEapProfile(input: $input) {
      ok
      errors {
        field
        code
        message
      }
    }
  }
`;
